// extracted by mini-css-extract-plugin
export default {"outdoorWrapper":"OutdoorAreasContent_outdoorWrapper__jS3D1","mapColumn":"OutdoorAreasContent_mapColumn__F7tc3","infoColumn":"OutdoorAreasContent_infoColumn__cjXgs"};